import * as yup from 'yup';

const validationSchema = yup.object().shape({
    email: yup.string().email().required('Required'),
    password: yup
        .string()
        .min(4, 'Must be more than 3 symbols')
        .max(16, 'Must be less than 17 symbols')
        .required('Required'),
});

export default validationSchema;
